import React from 'react';
import { flatten, chain } from 'lodash';
import { benefitTypesPosMapping } from '../constants';
import BenefitIcons from '../views/containers/SiteDetails/components/benefitIcons';

/* eslint-disable no-param-reassign */
export const getFirstN = (obj, n) =>
  chain(obj)
    .keys()
    .takeRight(n)
    .reduce((memo, current) => {
      memo[current] = obj[current];
      return memo;
    }, {})
    .value();
/* eslint-enable no-param-reassign */

/**
 * Get benefits from assets
 * @param {Array} assets
 * @returns {Array} array of objects with count and type
 */
export const getBenifits = assets => {
  const allPrgmObjectives = flatten(
    assets.map(asset => asset.pai.benefitsWithCount),
  );

  const benefits = allPrgmObjectives.reduce((acc, cur) => {
    const { id } = cur.type;
    if (acc[id]) {
      acc[id].count += 1;
    } else {
      acc[id] = {
        count: 1,
        pos: benefitTypesPosMapping[id] || 100,
        type: cur.type,
      };
    }
    return acc;
  }, {});
  return Object.values(benefits).sort((a, b) => {
    if (a.pos > b.pos) {
      return 1;
    }
    if (a.pos < b.pos) {
      return -1;
    }
    return 0;
  });
};

/**
 * Get label array for statusbar
 * @param {Array} benefits
 * @returns {Array} Array of objects with label, count and icon
 */
export const getBenefitSummaryArr = benefits =>
  benefits.map(benefit => {
    const benefitSummaryArr = {
      label: benefit.type.dn,
      count: benefit.count,
      icon: <BenefitIcons benefit={benefit.type.id} />,
    };
    return benefitSummaryArr;
  });
